/** Shared constants for admin impersonation feature */

export const IMPERSONATION_USER_ID_KEY = 'impersonateUserId'
export const IMPERSONATION_EMAIL_KEY = 'impersonateUserEmail'
export const IMPERSONATION_ACCOUNT_ID_KEY = 'impersonateAccountId'
export const IMPERSONATION_ACCOUNT_LABEL_KEY = 'impersonateAccountLabel'
export const IMPERSONATION_HEADER = 'X-Impersonate-User-Id'

/** Cookie names for SSR pages to read impersonation context */
export const IMPERSONATION_COOKIE = '__impersonate_uid'
export const IMPERSONATION_ACCOUNT_COOKIE = '__impersonate_aid'

/** Temporary localStorage keys for cross-tab transfer (admin -> impersonated tab) */
export const IMPERSONATION_EMAIL_TRANSFER_KEY = '_impersonateEmailTransfer'
export const IMPERSONATION_LABEL_TRANSFER_KEY = '_impersonateLabelTransfer'

/**
 * Open impersonation tab. Optional accountId pins the impersonation session
 * to a specific cabinet; accountLabel — человеческое имя того же кабинета,
 * показывается в баннере и свитчере во вкладке.
 */
export function startImpersonation(userId: string, email: string, accountId?: string, accountLabel?: string) {
    localStorage.setItem(IMPERSONATION_EMAIL_TRANSFER_KEY, email)
    if (accountLabel) localStorage.setItem(IMPERSONATION_LABEL_TRANSFER_KEY, accountLabel)
    const params = new URLSearchParams({ impersonate: userId })
    if (accountId) params.set('accountId', accountId)
    window.open(`/lk/dashboard?${params.toString()}`, '_blank')
}

export function clearImpersonation() {
    sessionStorage.removeItem(IMPERSONATION_USER_ID_KEY)
    sessionStorage.removeItem(IMPERSONATION_EMAIL_KEY)
    sessionStorage.removeItem(IMPERSONATION_ACCOUNT_ID_KEY)
    sessionStorage.removeItem(IMPERSONATION_ACCOUNT_LABEL_KEY)
    // Clear SSR cookies
    document.cookie = `${IMPERSONATION_COOKIE}=; path=/; max-age=0; SameSite=Strict`
    document.cookie = `${IMPERSONATION_ACCOUNT_COOKIE}=; path=/; max-age=0; SameSite=Strict`
}

export function getImpersonationAccountLabel(): string | null {
    if (typeof window === 'undefined') return null
    return sessionStorage.getItem(IMPERSONATION_ACCOUNT_LABEL_KEY)
}

/** Set the impersonation cookie so SSR pages can read it */
export function setImpersonationCookie(userId: string) {
    // Session cookie (no max-age) so it dies with the browser, SameSite=Strict, Secure on HTTPS
    const secure = window.location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = `${IMPERSONATION_COOKIE}=${encodeURIComponent(userId)}; path=/; SameSite=Strict${secure}`
}

export function setImpersonationAccountCookie(accountId: string) {
    const secure = window.location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = `${IMPERSONATION_ACCOUNT_COOKIE}=${encodeURIComponent(accountId)}; path=/; SameSite=Strict${secure}`
}

export function getImpersonationUserId(): string | null {
    if (typeof window === 'undefined') return null
    return sessionStorage.getItem(IMPERSONATION_USER_ID_KEY)
}

export function getImpersonationAccountId(): string | null {
    if (typeof window === 'undefined') return null
    return sessionStorage.getItem(IMPERSONATION_ACCOUNT_ID_KEY)
}

export function isImpersonating(): boolean {
    return getImpersonationUserId() !== null
}
